const downloadCsv = (csv: string, filename: string): void => {
  const universalBOM = '\uFEFF';
  const csvFile = new Blob([universalBOM + csv], { type: 'text/csv' });
  const downloadLink = document.createElement('a');
  downloadLink.download = filename;
  const url = URL.createObjectURL(csvFile);
  downloadLink.href = url;
  downloadLink.style.display = 'none';
  document.body.appendChild(downloadLink);
  downloadLink.click();
  URL.revokeObjectURL(url);
  downloadLink.remove();
};

export default downloadCsv;
